module.exports = __webpack_public_path__ + "img/CambiarPaqueteLatino.d1855ad0.png";